import { ApolloClient, InMemoryCache } from '@apollo/client'
import staticConfig from 'src/config'
import { networksEnvironments } from 'src/config/networks'
import { createRetryLink } from './utils'

const defaultNetworkEnv = networksEnvironments[staticConfig.defaultChain.id]

const link = createRetryLink( defaultNetworkEnv.subgraphUrls.swarm)

const swarmClient = new ApolloClient({
  link: link,
  cache: new InMemoryCache(),
})

export default swarmClient
